import React from 'react'
import { ResortItem as ResortItemData } from '../Resorts'
import ResortItem from './views/ResortItem'

type ResortItemsProps = {
    resortsData : ResortItemData[]
}

const ResortItems = ({resortsData}: ResortItemsProps) => {
  return (
    <section>
        <div className="column-resort-items">
            {
                resortsData.map( resort => 
                <ResortItem
                    key={resort.id}
                    image={resort.image}
                    link={resort.link}
                    short_description={resort.short_description}
                    title={resort.title}
                />)
            }
        </div>
    </section>
  )
}

export default ResortItems